import { ISmarcador, Marcador } from "../marcador/Marcador";
import { IStipoProcesso, TipoProcesso } from "../tipoProcesso/TipoProcesso";
import { ISusuarioList, UsuarioList } from "../usuario/UsuarioList";
import { Documento } from "./Documento";
import { ISprocesso, Processo } from "./Processo";

export interface ProcessoMarcador {
    id: string;   
    usuario: UsuarioList;
    dataHoraCriacao: Date | null;
    processo: Processo;
    marcador: Marcador;
}

export const ISprocessoMarcador: ProcessoMarcador = {
    id: "",    
    usuario: ISusuarioList,
    dataHoraCriacao: null,
    processo: ISprocesso,
    marcador: ISmarcador,
}